const tabSelector = '.js--cabinet__nav';
const tabList = document.querySelectorAll(`${tabSelector} .js--cabinet__nav_link`);


if (tabList) {
    tabList.forEach((item) => {
        item.addEventListener('shown.bs.tab', event => {
            item.scrollIntoView({block: "center", inline: "center"});
        });
    });
}
